<template>
  <div id="App">
    <van-nav-bar
      :title="Worker.Name == '' ? '新增工人' : Worker.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
    />
    <van-form @submit="doSave">
      <van-tabs v-model="activeName" scrollspy sticky style="text-align:center">
        <van-tab title="上传身份证" name="1">
          <van-cell-group>
            <van-row>
              <van-col span="12">
                <van-uploader
                  v-model="sfzRX"
                  multiple
                  capture="camera"
                  max-count="1"
                  :after-read="afterSfzRxRead"
                  style="margin-top:20px;"
                />
                <van-cell
                  title="身份证(人像)"
                  class="zz-title"
                  style="text-align: center;"
                />
              </van-col>
              <van-col span="12">
                <van-uploader
                  v-model="sfzGH"
                  multiple
                  capture="camera"
                  max-count="1"
                  :after-read="afterSfzGhRead"
                  style="margin-top:20px;"
                />
                <van-cell
                  title="身份证(国徽)"
                  class="zz-title"
                  style="text-align: center;"
                />
              </van-col>
            </van-row>
          </van-cell-group>
        </van-tab>
        <van-tab title="人员信息" name="2">
          <van-cell-group>
            <van-field
              v-model="workerInfo.grxm"
              label="工人姓名"
              placeholder="工人姓名"
              required
              :rules="[{ required: true, message: '请填写工人姓名' }]"
            />
            <van-field
              v-model="workerInfo.zjhm"
              label="证件号码"
              placeholder="证件号码"
              required
              :rules="[{ required: true, message: '请填写证件号码' }]"
            />
            <van-field
              v-model="workerInfo.mz"
              label="民族"
              placeholder="民族"
              required
              :rules="[{ required: true, message: '请填写民族' }]"
            />
            <van-field
              v-model="workerInfo.zz"
              label="住址"
              placeholder="住址"
              required
              :rules="[{ required: true, message: '请填写住址' }]"
            />
            <van-field
              v-model="workerInfo.fzjg"
              label="发证机关"
              placeholder="发证机关"
              required
              :rules="[{ required: true, message: '请填写发证机关' }]"
            />
            <van-field
              v-model="workerInfo.yxqks"
              label="有效期开始"
              placeholder="有效期开始"
              required
              :rules="[{ required: true, message: '请填写有效期开始' }]"
              readonly
              @click="
                showDate = true;
                dateType = 0;
              "
            />
            <van-field
              v-model="workerInfo.yxqjs"
              label="有效期结束"
              placeholder="有效期结束"
              required
              :rules="[{ required: true, message: '请填写有效期结束' }]"
              readonly
              @click="
                showDate = true;
                dateType = 1;
              "
            />

            <van-row>
              <van-col span="7">
                <van-button
                  native-type="button"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  style="margin-top:50px;"
                  size="small"
                  @click="changeTX(-90)"
                  :v-show="this.tx.length > 0"
                  >逆时针旋转</van-button
                >
              </van-col>
              <van-col span="10">
                <van-uploader
                  v-model="tx"
                  multiple
                  capture="camera"
                  :max-count="1"
                  :after-read="afterTxRead"
                  style="margin-top:20px;"
                />
              </van-col>
              <van-col span="7">
                <van-button
                  native-type="button"
                  color="linear-gradient(to right, #ee0a24, #ff6034)"
                  style="margin-top:50px;"
                  size="small"
                  @click="changeTX(90)"
                  :v-show="this.tx.length > 0"
                  >顺时针旋转</van-button
                >
              </van-col>
            </van-row>
            <van-cell
              title="头像"
              class="zz-title"
              style="text-align: center;"
              required
            />
            <van-field
              v-model="workerInfo.kqkh"
              label="考勤卡号"
              placeholder="考勤卡号"
              required
              :rules="[{ required: true, message: '请填写考勤卡号' }]"
            />
            <van-field
              v-model="workerInfo.sjhm"
              label="手机号码"
              placeholder="手机号码"
              required
              :rules="[{ required: true, message: '请填写手机号码' }]"
            />
            <van-field
              v-model="workerInfo.zzmm"
              label="政治面貌"
              placeholder="政治面貌"
              required
              :rules="[{ required: true, message: '请选择政治面貌' }]"
              readonly
              @click="showZZMM = true"
            />
            <van-field
              v-model="workerInfo.whcd"
              label="文化程度"
              placeholder="文化程度"
              required
              :rules="[{ required: true, message: '请选择文化程度' }]"
              readonly
              @click="showWHCD = true"
            />
            <van-field
              v-model="workerInfo.grlx"
              label="工人类型"
              placeholder="工人类型"
              required
              :rules="[{ required: true, message: '请选择工人类型' }]"
              readonly
              @click="showGRLX = true"
            />
            <van-field
              v-model="workerInfo.gz"
              label="工种"
              placeholder="工种"
              required
              :rules="[{ required: true, message: '请选择工种' }]"
              readonly
              @click="showGZ = true"
            />
            <van-field
              v-model="workerInfo.gzyhk"
              label="工资银行卡号"
              placeholder="工资银行卡号"
            >
              <template #button>
                <van-uploader
                  multiple
                  capture="camera"
                  max-count="1"
                  :after-read="aftergzyhkRead"
                >
                  <van-icon name="photograph" size="20" />
                </van-uploader>
              </template>
            </van-field>
            <van-field
              v-model="workerInfo.gzyh"
              label="工资银行名称"
              placeholder="工资银行名称"
            />
            <van-field
              v-model="workerInfo.gzlx"
              label="工资类型"
              placeholder="工资类型"
              readonly
              @click="showGZLX = true"
            />
            <van-field
              v-model="workerInfo.gzje"
              label="工资"
              placeholder="工资"
            />
          </van-cell-group>
        </van-tab>
        <van-tab title="照片拍摄" name="3">
          <van-cell-group>
            <van-row>
              <van-col span="4">
                <van-button
                  native-type="button"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  style="margin-top:80px;"
                  size="small"
                  @click="changemMJ(-90)"
                  :v-show="this.tx.length > 0"
                  >逆时针</van-button
                >
              </van-col>
              <van-col span="16">
                <van-uploader
                  v-model="mj"
                  multiple
                  v-if="isiOS"
                  :max-count="1"
                  :after-read="afterMjRead"
                  preview-size="200"
                  style="margin-top:20px;"
                />
                <van-uploader
                  v-model="mj"
                  multiple
                  capture="camera"
                  v-if="!isiOS"
                  :max-count="1"
                  :after-read="afterMjRead"
                  preview-size="200"
                  style="margin-top:20px;"
                />
              </van-col>
              <van-col span="4">
                <van-button
                  native-type="button"
                  color="linear-gradient(to right, #ee0a24, #ff6034)"
                  style="margin-top:80px;"
                  size="small"
                  @click="changemMJ(90)"
                  :v-show="this.tx.length > 0"
                  >顺时针</van-button
                >
              </van-col>
            </van-row>
            <van-row>
              <van-col span="4"> </van-col>
              <van-col span="16">
                <van-cell
                  title="门禁人脸照片"
                  class="zz-title"
                  style="text-align: center;"
                />
              </van-col>
              <van-col span="4">
                <van-button
                  @click="
                    qmheight = '508px';
                    qmweight = '325px';
                    showqm = !showqm;
                  "
                  size="small"
                  native-type="button"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  >签名</van-button
                >
              </van-col>
            </van-row>
          </van-cell-group>
        </van-tab>
        <van-row gutter="20" style="margin-top:20px;margin-bottom:50px;">
          <van-col span="2"></van-col>
          <van-col span="20">
            <van-button
              v-show="!showqm"
              round
              block
              type="danger"
              native-type="submit"
              color="linear-gradient(to right, #ff6034, #ee0a24)"
            >
              提交
            </van-button>
          </van-col>
          <van-col span="2"></van-col>
        </van-row>
      </van-tabs>
    </van-form>
    <van-popup
      v-model="showqm"
      :style="{ height: this.qmheight, width: this.qmweight }"
    >
      <VueSignaturePad
        id="signature"
        width="320px"
        height="450px"
        ref="signaturePad"
        v-show="this.workerInfo.qm == null || this.workerInfo.qm == ''"
        :options="this.options"
      />
      <van-image
        width="320px"
        height="450px"
        v-show="this.workerInfo.qm != null && this.workerInfo.qm != ''"
        class="re"
        :src="
          this.workerInfo.qm != null && this.workerInfo.qm != ''
            ? this.webUrl + this.workerInfo.qm.replace('..', '')
            : ''
        "
      />
      <van-button
        native-type="button"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        class="re"
        @click="showqm = !showqm"
        >确定</van-button
      >
      <van-button
        native-type="button"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        class="re"
        @click="undo"
        >清除</van-button
      >
    </van-popup>
    <van-popup
      v-model="showDate"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="selDate"
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup
      v-model="showZZMM"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择政治面貌"
        show-toolbar
        :columns="ZZMMcolumns"
        @confirm="selZzmm"
        @cancel="showZZMM = false"
      />
    </van-popup>
    <van-popup
      v-model="showWHCD"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择文化程度"
        show-toolbar
        :columns="WHCDcolumns"
        @confirm="selWhcd"
        @cancel="showWHCD = false"
      />
    </van-popup>
    <van-popup
      v-model="showGRLX"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择工人类型"
        show-toolbar
        :columns="GRLXcolumns"
        @confirm="selGRLX"
        @cancel="showGRLX = false"
      />
    </van-popup>
    <van-popup
      v-model="showGZ"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择工种"
        show-toolbar
        value-key="SYC_NAME"
        :columns="GZcolumns"
        @confirm="selGZ"
        @cancel="showGZ = false"
      />
    </van-popup>

    <van-popup
      v-model="showGZLX"
      position="bottom"
      :style="{ height: '260px' }"
      round
    >
      <van-picker
        title="选择工资类型"
        show-toolbar
        :columns="GZLXcolumns"
        @confirm="selGZLX"
        @cancel="showGZLX = false"
      />
    </van-popup>
    <van-overlay :show="finished">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>
<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.zz-title {
  color: lightslategray;
  text-align: left;
}
#signature {
  border: solid 1px #333;
  max-width: 400px;
  background-image: linear-gradient(white, white);
}
.re {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* Internet Explorer 9*/
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
</style>
<script>
import { mapState } from "vuex";
import { Dialog } from "vant";

export default {
  data() {
    return {
      isiOS: false,
      showqm: true,
      qmheight: "0px",
      qmweight: "0px",
      finished: false,
      Worker: {
        Code: "",
        Name: "",
        Team: {
          Code: "",
          Name: "",
          Pro: {
            Code: "",
            Name: ""
          }
        }
      },
      options: {
        penColor: "#000"
      },
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2099, 11, 31),
      currentDate: new Date(),
      dateType: 0,
      showDate: false,
      showReturn: true,
      showZZMM: false,
      ZZMMcolumns: [
        "中共党员",
        "中共预备党员",
        "共青团员",
        "民革党员",
        "民盟盟员",
        "民建会员",
        "民进会员",
        "农工党党员",
        "致公党党员",
        "九三学社社员",
        "台盟盟员",
        "无党派人士",
        "群众"
      ],
      showWHCD: false,
      WHCDcolumns: [
        "小学",
        "初中",
        "高中",
        "中专",
        "大专",
        "本科",
        "硕士",
        "博士",
        "其他"
      ],
      showGRLX: false,
      GRLXcolumns: ["建筑工人", "管理人员"],
      showGZ: false,
      GZcolumns: [],
      sfzRX: [],
      sfzGH: [],
      tx: [],
      mj: [],
      activeName: "1",
      workerInfo: {
        grxm: "",
        zjhm: "",
        mz: "",
        zz: "",
        fzjg: "",
        yxqks: "",
        yxqjs: "",
        kqkh: "",
        sjhm: "",
        zzmm: "群众",
        whcd: "小学",
        grlx: "建筑工人",
        gz: "",
        gzyhk: "",
        gzyh: "",
        gzlx: "点工工资",
        gzje: "",
        qm: null
      },
      showGZLX: false,
      GZLXcolumns: ["点工工资", "包工工资", "固定工资"]
    };
  },
  computed: {
    ...mapState(["userInfo", "webUrl", "tempQuery"])
  },
  methods: {
    selGZLX(value) {
      var that = this;
      that.workerInfo.gzlx = value;
      that.getGZJE();
    },
    getGZJE() {
      var that = this;
      //根据工资类型和班组编号带出工资金额
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWorkGZJE",
            Params: [that.workerInfo.gzlx, that.Worker.Team.Code]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.workerInfo.gzje = response.data.Table[0].GZJE;
          } else {
            Dialog({ message: response.data.msg });
          }
          that.showGZLX = false;
        })
        .catch(error => {
          Dialog({ message: error.message });
          that.showGZLX = false;
        });
    },
    selGZ(value) {
      this.workerInfo.gz = value.SYC_NAME;
      this.showGZ = false;
    },
    getGRGZ() {
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWorkType",
            Params: [that.workerInfo.grlx, that.Worker.Team.Code]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.GZcolumns = response.data.Table;
          } else {
            Dialog({ message: response.data.msg });
          }
        })
        .catch(error => {
          Dialog({ message: error.message });
        });
    },
    selGRLX(value) {
      this.showGRLX = false;
      if (value != this.workerInfo.grlx) {
        this.workerInfo.grlx = value;
        this.workerInfo.gz = "";
        this.getGRGZ();
      }
    },
    selWhcd(value) {
      this.workerInfo.whcd = value;
      this.showWHCD = false;
    },
    selZzmm(value) {
      this.workerInfo.zzmm = value;
      this.showZZMM = false;
    },
    selDate(value) {
      if (value != null && value != "") {
        if (this.dateType == "0") {
          this.workerInfo.yxqks = value.format("yyyy-MM-dd");
          this.showDate = false;
        } else {
          this.workerInfo.yxqjs = value.format("yyyy-MM-dd");
          this.showDate = false;
        }
      }
    },
    undo() {
      this.$refs.signaturePad.clearSignature();
      this.workerInfo.qm = null;
    },
    onClickLeft() {
      var that = this;
      if (that.userInfo.loginType == "0") {
        this.$router.push("/workers");
      } else {
        that.$router.push({
          path: "/SelWorkerList",
          name: "SelWorkerList"
        });
      }
    },
    aftergzyhkRead(data) {
      data.status = "uploading";
      data.message = "上传中...";
      this.updateYHK(data);
    },
    updateYHK(data) {
      var that = this;
      that.imageCompress(data.content, 1024).then(data_con => {
        //用后台.Net方法调用文字识别算法
        that
          .$axios({
            method: "post",
            url: "/api/Tool",
            data: {
              Method: "getYhkInfo",
              Image: data_con
            },
            headers: {
              Authorization: "Bearer " + that.userInfo.token
            }
          })
          .then(response => {
            if (response.data.result.bank_card_number != null) {
              that.workerInfo.gzyhk = response.data.result.bank_card_number.replace(
                / /g,
                ""
              );
              that.workerInfo.gzyh = response.data.result.bank_name;
            } else {
              Dialog({ message: "身份证识别失败，请重启拍摄" });
            }
            data.status = "done";
            data.message = "";
          })
          .catch(error => {
            window.console.log(error);
            data.status = "done";
            data.message = "";
            Dialog({ message: error.message });
          });
      });
    },
    afterSfzRxRead(data) {
      data.status = "uploading";
      data.message = "上传中...";
      this.updateBD("front", data);
    },
    afterSfzGhRead(data) {
      data.status = "uploading";
      data.message = "上传中...";
      this.updateBD("back", data);
    },
    afterTxRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.updateRm(file, "tx");
    },
    afterMjRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.updateRm(file, "mj");
    },
    doSave() {
      //1.1  执行保存函数
      var that = this;
      that.finished = true;
      if ((that.tx.length > 0 ? that.tx[0].url : "") == "") {
        Dialog({ message: "请上传头像" });
        that.finished = false;
        return;
      }
      Dialog.confirm({
        title: "保存提交",
        message: "是否确认提交当前人员信息？"
      })
        .then(() => {
          const { isEmpty, data } = that.$refs.signaturePad.saveSignature();
          if (!isEmpty) {
            that.imageRotate(data, 1).then(data_con => {
              that.doSub(data_con);
            });
          } else {
            that.doSub("");
          }
          //2.1  判断数据有效性 OK
          //2.2  证件字符串加密 OK
          //2.3  保存数据到数据库 OK
          //2.4  人员信息上传到考勤机 OK
          //2.5  考勤图片上传到考勤机 OK
          //1.2  根据返回值，提示用户成功或失败
        })
        .catch(error => {
          if(error.message.indexOf("saveSignature") > 0)
          {
            that.doSub("");
          }
          else
          {
            Dialog({ message: error.message });
            that.finished = false;
          }
          return;
        });
    },

    doSub(qmdata) {
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Tool",
          data: {
            Method: "setWorkerInfo",
            CODE: that.Worker.Code,
            TeamCode: that.Worker.Team.Code,
            IssueCardPicUrl: that.mj.length > 0 ? that.mj[0].url : "",
            HeadImageUrl: that.tx.length > 0 ? that.tx[0].url : "",
            workerInfo: that.workerInfo,
            qmdata: qmdata
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.finished = false;
            Dialog({ message: "保存成功" });
          } else {
            Dialog({ message: response.data.msg });
            that.finished = false;
          }
        })
        .catch(error => {
          Dialog({ message: error.message });
          that.finished = false;
        });
    },
    //旋转
    imageRotate(base64, type) {
      if (base64 == null || base64 == "") {
        return null;
      }
      let Img = new Image();
      var dataURL = "";
      Img.src = base64;
      let p = new Promise(function(resolve) {
        Img.onload = function() {
          //要先确保图片完整获取到，这是个异步事件
          let canvas = document.createElement("canvas"), //创建canvas元素
            imgWidth = Img.width, //确保canvas的尺寸和图片一样
            imgHeight = Img.height;
          if (type == 1) {
            canvas.width = imgHeight;
            canvas.height = imgWidth;
            canvas.getContext("2d").rotate((3 * Math.PI) / 2);
            canvas
              .getContext("2d")
              .drawImage(Img, -imgWidth, 0, imgWidth, imgHeight);
          } else {
            canvas.width = imgHeight;
            canvas.height = imgWidth;
            canvas.getContext("2d").rotate(Math.PI / 2);
            canvas
              .getContext("2d")
              .drawImage(Img, 0, -imgHeight, imgWidth, imgHeight);
          }
          if (base64.indexOf("png") > 0) {
            dataURL = canvas.toDataURL("image/png", 1); //转换图片为dataURL
          } else {
            dataURL = canvas.toDataURL("image/jpeg", 1); //转换图片为dataURL
          }
          resolve(dataURL);
        };
      });
      return p;
    },
    //上传base64图片到服务器
    updateRm(data, type) {
      var that = this;
      that.imageCompress(data.content, 1024).then(data_con => {
        that
          .$axios({
            method: "post",
            url: "/api/Tool",
            data: {
              Method: "uploadImg",
              ImgBuffer: data_con
            },
            headers: {
              Authorization: "Bearer " + that.userInfo.token
            }
          })
          .then(response => {
            if (response.data.status == "200") {
              if (type == "tx") {
                that.tx = [
                  {
                    url:
                      response.data.imgPath == null ||
                      response.data.imgPath == ""
                        ? ""
                        : response.data.imgPath
                  }
                ];
              } else if (type == "mj") {
                that.mj = [
                  {
                    url:
                      response.data.imgPath == null ||
                      response.data.imgPath == ""
                        ? ""
                        : response.data.imgPath
                  }
                ];
              }
            } else {
              Dialog({ message: "图片上传是失败" });
            }
            data.status = "done";
            data.message = "";
          })
          .catch(error => {
            window.console.log(error);
            data.status = "done";
            data.message = "";
            //弹出失败提醒
            Dialog({ message: error.message });
          });
      });
    },
    //上传base64图片到服务器
    updateRm2(data_con, type) {
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Tool",
          data: {
            Method: "uploadImg",
            ImgBuffer: data_con
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            if (type == "tx") {
              that.tx = [
                {
                  url:
                    response.data.imgPath == null || response.data.imgPath == ""
                      ? ""
                      : response.data.imgPath
                }
              ];
            } else if (type == "mj") {
              that.mj = [
                {
                  url:
                    response.data.imgPath == null || response.data.imgPath == ""
                      ? ""
                      : response.data.imgPath
                }
              ];
            }
          } else {
            Dialog({ message: "图片上传是失败" });
          }
        })
        .catch(error => {
          window.console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
        });
    },
    updateBD(Sides, data) {
      var that = this;
      that.imageCompress(data.content, 1024).then(data_con => {
        //用后台.Net方法调用文字识别算法
        that
          .$axios({
            method: "post",
            url: "/api/Tool",
            data: {
              Method: "getIdInfo_BD",
              Image: data_con,
              Side: Sides
            },
            headers: {
              Authorization: "Bearer " + that.userInfo.token
            }
          })
          .then(response => {
            if (
              response.data.image_status == "normal" ||
              response.data.image_status == "unknown"
            ) {
              if (response.data.words_result.姓名 != null) {
                that.workerInfo.grxm = response.data.words_result.姓名.words;
                that.workerInfo.mz = response.data.words_result.民族.words;
                that.workerInfo.zjhm =
                  response.data.words_result.公民身份号码.words;
                if (that.workerInfo.kqkh == "") {
                  that.workerInfo.kqkh =
                    response.data.words_result.公民身份号码.words;
                }
                that.workerInfo.zz = response.data.words_result.住址.words;
                that.updateRm2(
                  "data:image/jpg;base64," + response.data.photo,
                  "tx"
                );
              } else if (response.data.words_result.签发机关 != null) {
                that.workerInfo.fzjg =
                  response.data.words_result.签发机关.words;
                let qfrq = response.data.words_result.签发日期.words;
                if (qfrq.length == 8) {
                  that.workerInfo.yxqks =
                    qfrq.substring(0, 4) +
                    "-" +
                    qfrq.substring(4, 6) +
                    "-" +
                    qfrq.substring(6, 8);
                } else if (qfrq.length == 10) {
                  that.workerInfo.yxqks =
                    qfrq.substring(0, 4) +
                    "-" +
                    qfrq.substring(5, 7) +
                    "-" +
                    qfrq.substring(8, 10);
                }
                let sxrq = response.data.words_result.失效日期.words;
                if (sxrq.indexOf("长期") > -1) {
                  that.workerInfo.yxqjs = "2099-12-31";
                } else if (sxrq.length == 8) {
                  that.workerInfo.yxqjs =
                    sxrq.substring(0, 4) +
                    "-" +
                    sxrq.substring(4, 6) +
                    "-" +
                    sxrq.substring(6, 8);
                } else if (sxrq.length == 10) {
                  that.workerInfo.yxqjs =
                    sxrq.substring(0, 4) +
                    "-" +
                    sxrq.substring(5, 7) +
                    "-" +
                    sxrq.substring(8, 10);
                }
              } else {
                Dialog({ message: "身份证识别失败，请重启拍摄" });
              }
            } else {
              Dialog({ message: "身份证识别失败，请重启拍摄" });
            }
            data.status = "done";
            data.message = "";
          })
          .catch(error => {
            window.console.log(error);
            data.status = "done";
            data.message = "";
            //弹出失败提醒
            Dialog({ message: error.message });
          });
      });
    },
    // base64转blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //ArrayBuffer ---> Buffer
    toBuffer(ab) {
      var buf = new Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buf.length; ++i) {
        buf[i] = view[i];
      }
      return buf;
    },
    imageCompress(base64, maxh) {
      let Img = new Image();
      var dataURL = "";
      Img.src = base64;
      let p = new Promise(function(resolve) {
        Img.onload = function() {
          //要先确保图片完整获取到，这是个异步事件
          let canvas = document.createElement("canvas"), //创建canvas元素
            width = Img.width, //确保canvas的尺寸和图片一样
            height = Img.height;
          // 默认将长宽设置为图片的原始长宽，这样在长宽不超过最大长度时就不需要再处理
          let ratio = width / height,
            maxLength = maxh,
            newHeight = height,
            newWidth = width;
          // 在长宽超过最大长度时，按图片长宽比例等比缩小
          if (width > maxLength || height > maxLength) {
            if (width > height) {
              newWidth = maxLength;
              newHeight = maxLength / ratio;
            } else {
              newWidth = maxLength * ratio;
              newHeight = maxLength;
            }
          }
          canvas.width = newWidth;
          canvas.height = newHeight;
          canvas.getContext("2d").drawImage(Img, 0, 0, newWidth, newHeight); //将图片绘制到canvas中
          dataURL = canvas.toDataURL("image/jpeg", 0.6); //转换图片为dataURL
          resolve(dataURL);
        };
      });
      return p;
    },

    changeTX(jd) {
      var that = this;
      that.finished = true;
      if ((that.tx.length > 0 ? that.tx[0].url : "") == "") {
        Dialog({ message: "请上传头像" });
        that.finished = false;
        return;
      }
      that
        .$axios({
          method: "post",
          url: "/api/Tool",
          data: {
            Method: "setTXJD",
            HeadImageUrl: that.tx.length > 0 ? that.tx[0].url : "",
            Jd: jd
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.tx = [
              {
                url:
                  response.data.imgPath == null || response.data.imgPath == ""
                    ? ""
                    : response.data.imgPath
              }
            ];
            that.finished = false;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = false;
          }
        })
        .catch(error => {
          Dialog({ message: error.message });
          that.finished = false;
        });
    },
    changemMJ(jd) {
      var that = this;
      that.finished = true;
      if ((that.mj.length > 0 ? that.mj[0].url : "") == "") {
        Dialog({ message: "请上传门禁照片" });
        that.finished = false;
        return;
      }
      that
        .$axios({
          method: "post",
          url: "/api/Tool",
          data: {
            Method: "setTXJD",
            HeadImageUrl: that.mj.length > 0 ? that.mj[0].url : "",
            Jd: jd
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.mj = [
              {
                url:
                  response.data.imgPath == null || response.data.imgPath == ""
                    ? ""
                    : response.data.imgPath
              }
            ];
            that.finished = false;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = false;
          }
        })
        .catch(error => {
          Dialog({ message: error.message });
          that.finished = false;
        });
    }
  },
  created: function() {
    const u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var that = this;
    that.Worker = that.tempQuery;
    if (that.userInfo.loginType != "0") {
      that.$store.commit("setTempQuery", that.Worker.Team);
    }
    if (that.Worker.Name == "") {
      that.showqm = false;
      //初始化工资
      that.getGZJE();
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatTeamDefWorkType",
            Params: [that.Worker.Team.Code]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.workerInfo.grlx = response.data.Table[0].WorkerRole;
            that.getGRGZ();
            that.workerInfo.gz = response.data.Table[0].WorkType;
          } else {
            Dialog({ message: response.data.msg });
          }
        })
        .catch(error => {
          window.console.log(error);
          Dialog({ message: error.message });
        });
    } else {
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWorkerInfo",
            Params: [that.Worker.Code]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.workerInfo = response.data.Table[0];
            that.tx = [
              {
                url:
                  response.data.Table[0].tx == null ||
                  response.data.Table[0].tx == ""
                    ? ""
                    : that.webUrl + response.data.Table[0].tx.replace("..", "")
              }
            ];
            that.mj = [
              {
                url:
                  response.data.Table[0].mj == null ||
                  response.data.Table[0].mj == ""
                    ? ""
                    : that.webUrl + response.data.Table[0].mj.replace("..", "")
              }
            ];
            that.getGRGZ();
            that.showqm = false;
          } else {
            Dialog({ message: response.data.msg });
          }
        })
        .catch(error => {
          window.console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
        });
    }
  }
};

Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
</script>
